
import React from 'react';
import { colors } from '@mui/material';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import DashboardIcon from '@mui/icons-material/DashboardOutlined';
import HomeIcon from '@mui/icons-material/HomeOutlined';
import SettingsIcon from '@mui/icons-material/SettingsOutlined';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import SsidChartIcon from '@mui/icons-material/SsidChart';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import EditNoteIcon from '@mui/icons-material/EditNote';
import BrowserUpdatedIcon from '@mui/icons-material/BrowserUpdated';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import CellTowerIcon from '@mui/icons-material/CellTower';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import HiveIcon from '@mui/icons-material/Hive';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BentoIcon from '@mui/icons-material/Bento';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BallotIcon from '@mui/icons-material/Ballot';
import AirlineStopsIcon from '@mui/icons-material/AirlineStops';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import AirplaneTicketIcon from '@mui/icons-material/AirplaneTicket';
import SmartToyIcon from '@mui/icons-material/SmartToy';

import config from '../../../../configuration/configuration.js';

export default [
	{
		title: '',
		pages: [
			{
				title: 'Home',
				href: '/home',
				icon: HomeIcon,
			},
		],
	},
	{
		title: 'Beacon',
		projects: ['VMO2 Dashboards', 'VMO2 Ran', '3GSD', 'VMO2 Radio Design'],
		pages: [
			{
				title: 'Performance',
				href: '/Performance',
				icon: TroubleshootIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Blended',
				href: '/Blended',
				icon: CalendarViewMonthIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				children: [
					{
						title: 'Monthly Blended',
						children: [
							{
								title: 'Pack 1',
								href: '/Blended/MonthlyBlended1',
							},
							{
								title: 'Pack 2',
								href: '/Blended/MonthlyBlended2',
							}
						]
					},
					{
						title: 'Weekly Blended',
						href: '/Blended/WeeklyBlended',
					},
					{
						title: (
							<span data-title="Performance">
								Performance
								<small
									style={{
										marginLeft: 6,
										fontSize: 9,
										fontWeight: 700,
										color: '#fff',
										backgroundColor: '#f57c00',
										padding: '1px 5px',
										borderRadius: 3,
										verticalAlign: 'middle',
										letterSpacing: '0.05em',
									}}
								>
									BETA
								</small>
							</span>
						),
						beta: true,
						projects: ['VMO2 Ran'],
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						href: '/Blended/Performance',
					},
					{
						title: (
							<span data-title="Synthesis">
								Synthesis
								<small
									style={{
										marginLeft: 6,
										fontSize: 9,
										fontWeight: 700,
										color: '#fff',
										backgroundColor: '#f57c00',
										padding: '1px 5px',
										borderRadius: 3,
										verticalAlign: 'middle',
										letterSpacing: '0.05em',
									}}
								>
									BETA
								</small>
							</span>
						),
						projects: ['VMO2 Ran'],
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						href: '/Blended/Synthesis',
					}
				],
			},
			{
				title: 'Estimate Customer Experience',
				href: '/EstimateCustomerExperience',
				icon: TravelExploreIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Network Faults',
				href: '/NetworkFaultsDetector',
				icon: CellTowerIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: '5G',
						href: '/NetworkFaultsDetector/5G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: '4G',
						href: '/NetworkFaultsDetector/4G',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
				]
			},
			{
				title: 'Demand KPIs View',
				href: '/DemandKPIsView',
				icon: AppRegistrationIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
			},
			{
				title: 'Cluster KPIs View',
				href: '/Cluster',
				icon: HiveIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: 'Management',
						href: '/Cluster/Management',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: 'Demand KPIs View',
						href: '/Cluster/DemandKPIsView',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
					,
					{
						title: 'Lockdown KPI',
						href: '/Cluster/LockdownKPI',
						roles: ['Administrator'/* , 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client' */]
					}
				]
			},
			{
				title: 'Step In',
				href: '/StepIn',
				icon: EditNoteIcon,
				projects: ['VMO2 Dashboards', 'VMO2 Ran'],

				children: [
					{
						title: 'Management',
						href: '/StepIn/Management',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS']
					},
					{
						title: 'Timeline',
						href: '/StepIn/Timeline',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					}
				]
			},
			{
				title: '3GSD',
				href: '/Shutdown3g',
				icon: CellTowerIcon,
				projects: ['3GSD'],
				children: [
					{
						title: 'Cluster KPI',
						href: '/Shutdown3g/ClusterKpi',
						children: [
							{
								title: 'Hourly',
								href: '/Shutdown3g/ClusterKpi/Hourly',
							},
							{
								title: 'Daily',
								href: '/Shutdown3g/ClusterKpi/Daily',
							}
						]
					},
					{
						title: 'Cell KPI',
						href: '/Shutdown3g/CellKpi',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
						children: [
							{
								title: 'Hourly',
								href: '/Shutdown3g/CellKpi/Hourly',
								children: [
									{
										title: '2G',
										href: '/Shutdown3g/CellKpi/Hourly/2G',
									},
									{
										title: '3G',
										href: '/Shutdown3g/CellKpi/Hourly/3G',
									},
									{
										title: '4G',
										href: '/Shutdown3g/CellKpi/Hourly/4G',
									}
								]
							},
							{
								title: 'Daily',
								href: '/Shutdown3g/CellKpi/Daily',
								children: [
									{
										title: '2G',
										href: '/Shutdown3g/CellKpi/Daily/2G',
									},
									{
										title: '3G',
										href: '/Shutdown3g/CellKpi/Daily/3G',
									},
									{
										title: '4G',
										href: '/Shutdown3g/CellKpi/Daily/4G',
									}
								]
							}
						]
					},
					{
						title: 'Outliers',
						href: '/Shutdown3g/Outliers',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
					},
					{
						title: 'Data Integrity',
						href: '/Shutdown3g/DataIntegrity',
						roles: ['Administrator', 'Manager', 'CelfinetHQ']
					}
				]
			}
		],
	},
	{
		title: 'Radio Design',
		projects: ['VMO2 Radio Design'],
		pages: [
			{
				title: 'Activities',
				icon: ContentPasteSearchIcon,
				children: [
					{
						title: 'Tracker',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/RadioDesign/ActivitiesTracker',
					},
					{
						title: 'Map',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/RadioDesign/ActivitiesMap',
					},
					{
						title: 'Performance',
						roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client'],
						href: '/RadioDesign/ActivityPerformance',
					},
					{
						title: 'User Privileges',
						roles: ['Administrator', 'Manager'],
						href: '/RadioDesign/UserPrivileges',
					}
				]
			},
			{
				title: 'Traffic Trends',
				href: '/RadioDesign/TrafficTrends',
				icon: TrendingUpIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
			},
			{
				title: 'Weekly Update',
				href: '/RadioDesign/WeeklyUpdate',
				icon: AssignmentIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS', 'Client']
			}
		]
	},
	{
		title: 'NASP',
		projects: ['NASP'],
		pages: [
			{
				title: 'NASP Availability',
				href: '/nasp/naspAvailability',
				icon: BentoIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
			},
			{
				title: 'Emails Wrong Right',
				href: '/nasp/emailsWrongRight',
				icon: BallotIcon,
				roles: ['Administrator', 'Manager'],
			},
			{
				title: 'TEF Internal',
				href: '/nasp/tefInternal',
				icon: AirlineStopsIcon,
				roles: ['Administrator', 'Manager', 'CelfinetHQ'],
			},
			{
				title: 'Old Outages',
				href: '/nasp/oldOutages',
				icon: BlurOnIcon,
				roles: ['Administrator'],
			},
			{
				title: 'Back On Air',
				href: '/nasp/backOnAir',
				icon: AirplaneTicketIcon,
				roles: ['Administrator', 'Manager'],
			},
			{
				title: 'Helix',
				href: '/nasp/Helix',
				icon: SmartToyIcon,
				roles: ['Administrator', 'Manager'],
				children: [
					{
						title: 'Creations',
						href: '/nasp/helix/helixCreations',
					},
					{
						title: 'Changes',
						href: '/nasp/helix/helixChanges',
					},
				]
			}
		]
	},
	{
		title: 'Management',
		pages: [
			{
				title: 'Manage',
				href: '/management',
				roles: ['Administrator', 'Manager'],
				icon: SupervisorAccountIcon,
				children: [
					{
						title: 'Operators',
						href: '/management/operators',
					},
					{
						title: 'Users',
						href: '/management/users',
					}
				],
			},
			{
				title: 'Hangfire',
				href: `${config.API_URL}hangfire?access_token={token}`,
				target: '_blank',
				roles: ['Administrator'],
				icon: DesktopMacIcon
			},
			{
				title: 'Settings',
				href: '/management/settings',
				icon: SettingsIcon
			},
			{
				title: 'Data Integrity',
				href: '/management/dataIntegrity',
				roles: ['Administrator', 'Manager'],
				icon: QueryStatsIcon
			},
			{
				title: 'Data Management',
				href: '/DataManagement',
				icon: BrowserUpdatedIcon,
				projects: ['VMO2 Ran', 'VMO2 Radio Design'],
				roles: ['Administrator', 'Manager', 'CelfinetHQ', 'CelfinetOS'],
			},
			{
				title: 'Analytics Dashboard',
				href: '/management/AnalyticsDashboard',
				roles: ['Administrator', 'Manager'],
				icon: SsidChartIcon
			}
		],
	}
];
